import request from '@/utils/request'

export function fetchSubsiteAll() {
  return request({ url: '/subsite/All', method: 'get' })
}

export function moveSubsite(data) {
  return request({ url: '/subsite/move', method: 'post', data })
}

export function fetchSubsiteList(params) {
  return request({ url: '/subsite/index', method: 'get', params })
}

export function fetchSubsiteEdit(params) {
  return request({ url: '/subsite/edit', method: 'get', params })
}

export function saveSubsite(data) {
  return request({ url: '/subsite/save', method: 'post', data })
}

export function deleteSubsite(data) {
  return request({ url: '/subsite/delete', method: 'post', data })
}

export function fetchSubsiteQrcode(id) {
  return request({ url: '/subsite/qrcode', method: 'get', params: { id } })
}
